/**
 * @license
 * Copyright Tyler Technologies, Inc. 
 * License: Apache-2.0
 */
import { defineCustomElement } from '@tylertech/forge-core';
import { TimePickerComponent } from './time-picker';
export * from './time-picker-adapter';
export * from './time-picker-component-delegate';
export * from './time-picker-constants';
export * from './time-picker-core';
export * from './time-picker-utils';
export * from './time-picker';
export function defineTimePickerComponent() {
    defineCustomElement(TimePickerComponent);
}
